/**
 * @generated SignedSource<<3f436e93bd521332ceb63981cc682075>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SalesAssociatesModal_salesAssociate$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"SalesAssociatePasswordModal_salesAssociate">;
  readonly " $fragmentType": "SalesAssociatesModal_salesAssociate";
};
export type SalesAssociatesModal_salesAssociate$key = {
  readonly " $data"?: SalesAssociatesModal_salesAssociate$data;
  readonly " $fragmentSpreads": FragmentRefs<"SalesAssociatesModal_salesAssociate">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "SalesAssociatesModal_salesAssociate"
};

(node as any).hash = "32de3de59e6f4f6547aa9627a8cca805";

export default node;
